import type { HTMLAttributes, ReactNode } from 'react';

export function Card({ className = '', ...props }: HTMLAttributes<HTMLElement>) {
  return <section className={`v4-card ${className}`.trim()} {...props} />;
}

export function StatCard({ label, value, detail, tone = 'default' }: { label: string; value: string; detail: string; tone?: 'default' | 'good' | 'warning' }) {
  return (
    <Card className={`stat-card stat-card--${tone}`}>
      <span>{label}</span><strong>{value}</strong><p>{detail}</p>
    </Card>
  );
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return <Card className="empty-state"><span className="empty-state__mark">V4</span><h2>{title}</h2><p>{description}</p>{action}</Card>;
}
